import Backdraft from "backdraft-app/src/backdraft";

Backdraft.app("Shared/SignalExpression", function(app) {
  app.model("BooleanTerminal", "ExpressionTerminal", {
    type: function() {
      return 'Boolean';
    }
  });
});
